module.exports = __webpack_public_path__ + "static/media/acams-indepth.99e5dee8.pdf";